export const BannerType = {
  GIFT: "GIFT",
  IDME: "IDME",
  PODCAST: "PODCAST",
  WELCOME: "WELCOME",
  WELCOME_OFFER_BUNDLE: "WELCOME_OFFER_BUNDLE",
  REFERRAL: "REFERRAL",
  PROMOTION: "PROMOTION",
  CUSTOM: "CUSTOM",
  BFCM_PROSPECT: "BFCM_PROSPECT",
  BFCM_SUBSCRIBER: "BFCM_SUBSCRIBER",
};
